import { MY_PROFILE } from "@constants/routes";
import UserContext from "@context/UserContext";
import PasswordField from "@easydev/form/Password";
import { showNotification } from "@easydev/Notification";
import updatePasswordAccountMapper from "@mappers/Security/Account/UpdatePasswordAccount.mapper";
import updatePassword from "@services/Core/Account/updatePassword";
import ModifyConfirmation from "@shared/Modals/ModifyConfirmation";
import updatePasswordValidate from "@validators/Security/Account/UpdatePassword.validate";
import LockIcon from "mdi-react/LockIcon";
import { useContext, useState } from "react";
import { Field, Form } from "react-final-form";
import { generatePath, Link, useHistory } from "react-router-dom";
import {
  Button,
  ButtonToolbar,
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from "reactstrap";

const UpdatePassword = () => {
  const { currentUser } = useContext(UserContext);
  const [modalStatus, setModalStatus] = useState(false);
  const [formValues, setFormValues] = useState(undefined);
  const history = useHistory();

  const handleModalStatus = () => {
    setModalStatus(!modalStatus);
  };

  const handleUpdatePassword = (FormValues) => {
    setFormValues(FormValues);
    handleModalStatus();
  };

  const handleConfirmModify = () => {
    const userDto = updatePasswordAccountMapper(formValues);

    currentUser &&
      updatePassword(currentUser.uuid, userDto)
        .then(async () => {
          showNotification(
            "My Profile | Modify Password",
            "The user has been edited successfully.",
            "Success",
          );
          history.push(generatePath(MY_PROFILE));
        })
        .catch((error) => {
          showNotification(
            "My Profile | Modify",
            `An error occurred while modifying the user:  ${error?.response?.data?.error}`,
            "Danger",
          );
        })
        .finally(() => {
          handleModalStatus();
        });
  };

  return (
    <Container>
      <ModifyConfirmation
        title={"My Profile | Modify confirmation"}
        body={"Are you sure you want to update your password?"}
        modalStatus={modalStatus}
        handleModalStatus={handleModalStatus}
        handleConfirmModify={handleConfirmModify}
      />
      <Row>
        <Col md={12}>
          <h3 className="page-title">
            <LockIcon />
            My Profile | Modify Password
          </h3>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={12} lg={12} xl={8}>
          <Card>
            <CardBody>
              <Form
                onSubmit={(FormValues) => {
                  handleUpdatePassword(FormValues);
                }}
                validate={updatePasswordValidate}
              >
                {({ handleSubmit }) => (
                  <form
                    className="form form--horizontal"
                    onSubmit={handleSubmit}
                  >
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        Old Password
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="oldpassword"
                          component={PasswordField}
                          keyIcon
                          isAboveError
                        />
                      </div>
                    </div>

                    <div className="form__form-group">
                      <span className="form__form-group-label">Password</span>
                      <div className="form__form-group-field">
                        <Field
                          name="password"
                          component={PasswordField}
                          keyIcon
                          isAboveError
                        />
                      </div>
                    </div>
                    <div className="form__form-group">
                      <span className="form__form-group-label">
                        Confirm Password
                      </span>
                      <div className="form__form-group-field">
                        <Field
                          name="confirmpassword"
                          component={PasswordField}
                          keyIcon
                          isAboveError
                        />
                      </div>
                    </div>

                    <ButtonToolbar className="form__button-toolbar">
                      <Link to={MY_PROFILE}>
                        <Button type="button">
                          <span className="lnr lnr-chevron-left" />
                          Go Back
                        </Button>
                      </Link>
                      <Button color="success" type="submit">
                        <span className="lnr lnr-pencil" /> Modify
                      </Button>
                    </ButtonToolbar>
                  </form>
                )}
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default UpdatePassword;
